import { render } from "./DrListPage.vue?vue&type=template&id=45d465f9&scoped=true"
import script from "./DrListPage.vue?vue&type=script&lang=js"
export * from "./DrListPage.vue?vue&type=script&lang=js"

import "./DrListPage.vue?vue&type=style&index=0&id=45d465f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d465f9"]])

export default __exports__